export const api = 'https://console.airdisk.cc';
// export const api = "";

